var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32.7516 17.4823L0 0V35.29L32.7516 17.4823Z","fill":"#FBFBFB"}));
}

PlayIcon.defaultProps = {"width":"33","height":"36","viewBox":"0 0 33 36","fill":"none"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
